/* eslint-disable no-unsafe-optional-chaining */
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Pana from '../../../assets/pana.png';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import './triad.scss';
import { useUpdateTriadMutation } from './triad.slice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface TriadThirdTabProps {
    setTriadPageNumber: React.Dispatch<React.SetStateAction<number>>;
    handleThirdTab: (display: boolean) => void;
    triadId: number | string;
    currTriad: any;
}

export const TriadThirdTab = (props: TriadThirdTabProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [UpdateTriad] = useUpdateTriadMutation();
    const [overallComments, setOverallComments] = useState(props?.currTriad?.overall_comment || '');
    const [isAuthor, setIsAuthor] = useState(false);
    useEffect(() => {
        if (props?.currTriad?.author_employee_number === loggedEmpNum) {
            setIsAuthor(true);
        }
    }, [props?.currTriad]);
    const handleSupervisorReview = () => {
        if (props?.currTriad?.employee_number !== loggedEmpNum) {
            toast.error('Only Supervisors are authorized to review');
            return;
        }

        if (!props?.currTriad?.acknowledged && props?.currTriad?.employee_number === loggedEmpNum) {
            const payload = {
                triadId: props?.triadId,
                assessmentScore: props?.currTriad?.assessment_score,
                acknowledgeEmployeeNumber: loggedEmpNum,
                acknowledgeDate: new Date(),
                acknowledged: true,
                overallComment: overallComments,
            };
            UpdateTriad(payload)
            .unwrap()
            .then((res: any) => {
                if (res.statusCode === 200) {
                    props?.handleThirdTab(true);
                    toast.success('Coaching Observations Acknowledged Successfully');
                } else {
                    toast.error('Coaching Observations Acknowledged Failed');
                }
            })
            .catch((err: any) => {
                toast.error(err);
            });
        } else {
            toast.info('Coaching Observations cannot be edited after Team lead has acknowledged.');
        }
    };
    const handleUpdateOverallComment = () => {
        if (props?.currTriad?.author_employee_number !== loggedEmpNum) {
            toast.error('Only Author is authorized to add comments');
            return;
        }
        if (overallComments?.length > 0) {
            const payload = {
                triadId: props?.triadId,
                assessmentScore: props?.currTriad?.assessment_score,
                acknowledgeEmployeeNumber: props?.currTriad?.acknowledge_employee_number,
                acknowledgeDate: props?.currTriad?.acknowledge_date,
                acknowledged: props?.currTriad?.acknowledged,
                overallComment: overallComments,
            };
            UpdateTriad(payload)
            .unwrap()
            .then((res: any) => {
                if (res.statusCode === 200) {
                    props?.handleThirdTab(true);
                    toast.success('Coaching Observation Comments updated Successfully');
                } else {
                    toast.error('Coaching Observation Comments updated Failed');
                }
            })
            .catch((err: any) => {
                toast.error(err);
            });
        }
        props?.setTriadPageNumber(0);
    };

    const handleDescriptionChange = (value: string) => {
        setOverallComments(value);
    };

    return (
        <div>
            <h3 className="margin-top-20">Coaching Assessment</h3>
            <h5>Results</h5>
            <div className="row">
                <div className="col-md-8 center-display">
                    <h4>
                        Coaching Assessment Score: <br />
                        {props?.currTriad && props?.currTriad?.assessment_score
                            ? (props.currTriad?.assessment_score * 100).toFixed(2) + '%'
                            : 'Does not Apply'}
                    </h4>
                </div>
                <div className="col-md-4">
                    <img src={Pana} alt="pana" />
                </div>
            </div>
            <div className="flex-display">
                <Checkbox
                    checked={props?.currTriad?.acknowledged}
                    onChange={handleSupervisorReview}
                    disabled={
                        props?.currTriad?.month !== new Date().getMonth() + 1 ||
                        props?.currTriad?.year !== new Date().getFullYear()
                    }
                />
                <p style={{ marginBottom: '0px', marginLeft: '10px' }}>
                    I have reviewed the Coaching Observations with my manager and acknowledge the review.
                </p>
            </div>
            <div style={{ fontWeight: 'bold', marginTop: '25px', marginBottom: '15px' }}>
                <DescriptionBox
                    title="Additional Comments"
                    responseDescription={overallComments}
                    value={overallComments}
                    limit={1000}
                    onChange={handleDescriptionChange}
                    readOnly={
                        !isAuthor ||
                        props?.currTriad?.acknowledged ||
                        (props?.currTriad?.month && props?.currTriad?.month !== new Date().getMonth() + 1) ||
                        (props?.currTriad?.year && props?.currTriad?.year !== new Date().getFullYear())
                    }
                    placeholder="Enter your comments here"
                />
            </div>
            <p style={{ color: '#3299FF' }} className="margin-top-20">
                *Link* Engage Enablement
            </p>
            {
                <div className="button-container-triad">
                    <Button
                        label="Back"
                        onClick={() => props?.setTriadPageNumber(2)}
                        className="btn-secondary"
                    />
                    <Button
                        visible={isAuthor && !props?.currTriad?.acknowledged}
                        label="Save & Close"
                        onClick={handleUpdateOverallComment}
                        className="btn-primary"
                    />
                    <Button
                        visible={!isAuthor || props?.currTriad?.acknowledged}
                        label="Close"
                        onClick={() => props?.setTriadPageNumber(0)}
                        className="btn-secondary"
                    />
                </div>
            }
        </div>
    );
};
